// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2jaPe","rightAdornment":"Header_rightAdornment__3lXgN"};